module.exports = "https://redage.akamaized.net/src/views/player/documets/ems/images/serial.png";